import './App.css';
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from './Pages/Homepage/Home/Home';
import ProjectDetails from './Pages/ProjectDetails/ProjectDetails';
import Blog from './Pages/Homepage/Blog/Blog';


function App() {
  const font = {
    fontFamily: "'M PLUS 1 Code', sans-serif",
    overflowX: "hidden"
  }
  return (
    
    <div style={font}>
      <BrowserRouter>
        <Routes>
          <Route exact path="/" element={<Home />}></Route>
          <Route path="home" element={<Home />}></Route>
          <Route path="/project/:project" element={<ProjectDetails />}></Route>
          <Route path="/blog" element={<Blog />}></Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
